import Router, { useRouter } from 'next/router';
import React, { memo, useCallback, useMemo } from 'react';

import { Grid, Layout } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { ArrowButton } from '@src/components/item/ArrowButton';
import { TOP_PAGE_ANCHOR } from '@src/constants/common';
import { scrollToElementById } from '@src/helpers/common';
import { useHistoryPreviousLocation } from '@src/reducers/history';
import { createLinkProps } from '@src/utils/routing';

import styles from './styles.module.scss';

interface IProps {
  isSticky: boolean;
  history?: string[];
  style?: React.CSSProperties;
}

export const StickyActionsBlock: React.FunctionComponent<IProps> = memo((props: IProps) => {
  const { isSticky, style } = props;
  const isMobile = useIsMobile();
  const router = useRouter();
  const previousLocation = useHistoryPreviousLocation();

  const handleClickOnScrollTop = React.useCallback(() => {
    scrollToElementById(TOP_PAGE_ANCHOR, {
      offset: -50,
    });
  }, []);

  const { href, as } = createLinkProps('/list/', '/zaimy/');

  const handleClickBackButton = useCallback(() => {
    if (document?.referrer?.startsWith(window?.location?.origin)) {
      return router.back();
    }

    if (previousLocation && previousLocation !== router.asPath) {
      return router.back();
    }

    return Router.replace(href, as);
  }, [as, href, previousLocation, router]);

  const componentStyles = useMemo(
    () =>
      ({
        '--box-shadow': isSticky ? '0 0 15px 0 rgba(0, 0, 0, 0.1)' : undefined,
        ...style,
      } as React.CSSProperties),
    [isSticky, style],
  );

  if (!isMobile) return null;

  return (
    <div {...props} className={styles.wrapper} style={componentStyles}>
      <div className={styles.container}>
        <Layout className={styles.layout}>
          <Grid.Row justify="space-between">
            <Grid.Col>
              <ArrowButton
                className={styles.arrow_button}
                arrowPosition="left"
                arrowType="single"
                text="Назад"
                onClick={handleClickBackButton}
              />
            </Grid.Col>
            {isSticky ? (
              <Grid.Col>
                <ArrowButton className={styles.arrow_button} onClick={handleClickOnScrollTop} />
              </Grid.Col>
            ) : null}
          </Grid.Row>
        </Layout>
      </div>
    </div>
  );
});
